import { render } from "./IdFormularioFactory.vue?vue&type=template&id=4692527e&scoped=true&ts=true"
import script from "./IdFormularioFactory.vue?vue&type=script&lang=ts"
export * from "./IdFormularioFactory.vue?vue&type=script&lang=ts"

import "./IdFormularioFactory.vue?vue&type=style&index=0&id=4692527e&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4692527e"]])

export default __exports__